/** 场地（逻辑单位，贪吃是 360×640）怎么放进舞台：等比缩放、居中留边；指针位置换回场地坐标。 */

export interface Fit {
  scale: number;
  offsetX: number;
  offsetY: number;
  width: number;
  height: number;
}

export function fitArena(boxWidth: number, boxHeight: number, arenaWidth: number, arenaHeight: number): Fit {
  const scale = Math.max(0, Math.min(boxWidth / arenaWidth, boxHeight / arenaHeight));
  const width = arenaWidth * scale;
  const height = arenaHeight * scale;
  return { scale, width, height, offsetX: (boxWidth - width) / 2, offsetY: (boxHeight - height) / 2 };
}

/** 舞台内的点（相对舞台左上角，CSS 像素）换成场地坐标；舞台还没量出尺寸时为 null。不夹到场地里——规则核心会让宠物贴边停下。 */
export function toArena(fit: Fit, x: number, y: number): { x: number; y: number } | null {
  if (!(fit.scale > 0)) return null;
  return { x: (x - fit.offsetX) / fit.scale, y: (y - fit.offsetY) / fit.scale };
}
